angular
	.module('domain.activity', [
		'ngRoute',
		'upResources',
		'security.authorization',
		'services.customer',
		'services.templateCacher'
	])
	.config([
		'$stateProvider',
		'$routeGuardProvider',
		'$httpProvider',
		'$upModalProvider',
		function ($stateProvider, $routeGuardProvider, $httpProvider, $upModalProvider) {
			$stateProvider.state('activities', {
				templateUrl: require('App/upsales/common/directives/templates/upListView2.tpl.html?file'),
				url: '/:customerId/activities/',
				controller: 'ListActivities as listViewHelper',
				section: 'sale',
				resolve: {
					authUser: [
						'$routeGuard',
						function ($routeGuard) {
							return $routeGuard.requireUser();
						}
					],
					listViews: [
						'AppService',
						function (AppService) {
							return AppService.loadedPromise.then(function () {
								return AppService.getListViews('activity');
							});
						}
					],
					isAvailable: [
						'FeatureHelper',
						function (FeatureHelper) {
							return FeatureHelper.placeholder(FeatureHelper.Feature.ACTIVITIES_AND_APPOINTMENTS);
						}
					]
				}
			});

			$upModalProvider.modal('editActivity', {
				// Hand every caller to the React modal once REACT_EDIT_ACTIVITY is on
				// (WEB-10153). Everything below stays the flag-off path until the
				// Angular modal is retired on WEB-8899.
				forwardToReactModal: 'EditActivity',
				templateUrl: require('App/upsales/domain/activity/views/editActivity.html?file'),
				style: 'form default dynamic initially-hidden',
				controller: 'EditActivity as EditActivity',
				invisibleCurtain: true,
				rememberHeight: true,
				resolve: {
					meta: function ($modalParams, EditActivityMeta) {
						return EditActivityMeta($modalParams);
					}
				}
			});
		}
	]);
